import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { Breadcrumbs, Button, Typography } from "@material-ui/core";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));


const PartnerProductPackage = props => {
	const [nextPagePath, setNextPagePath] = useState("");
	const [idnoselected, setIdnoSelected] = useState("");
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [eligibleforrelease, setEligibleRel] = useState("");
    const [isFS, setIfFS] = useState("");
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] =  useState(get_cookies('branchidno'));
	const [grandTotal, setGrandTotal] = useState({"grand_total":0});

	useEffect(() => {
        props.history.push(nextpage);
    }, [nextPagePath]);


	const proceedtopackagedetails = () => {
        props.history.push(nextpage);
    }
	
	
const nextpage =  {
	// pathname: "/package-sales-payment",
	pathname: nextPagePath,
	idno: idnoselected,
	eligibleforrelease: eligibleforrelease,
	isfs:isFS
}

	const viewpackagedetails = (idno, eligible, fs) => {
        setNextPagePath("/package-sales-summary-details");
        setIdnoSelected(idno);
        if(eligible == "yes"){
            setEligibleRel("yes");
        }else{
            setEligibleRel("");
        }
        if(fs == "fs"){
            setIfFS("fs");
        }else{
            setIfFS("");
        }
        proceedtopackagedetails();
    }

	// Data Fetching
	useEffect(() => {
		setDataLoaded(true);
	}, []);
	
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);
	
	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
         await axios.get(
            process.env.REACT_APP_API_URL+'product_package_report', {
			params:{
                 date_from: format(dateRange.startDate, "yyyy/MM/dd/"), //format(dateRange.startDate, "yyyy/MM/dd/")
                 date_to: format(dateRange.endDate, "yyyy/MM/dd/"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                 jc_user_id_no: useridNo,  
             }
		}).then((res)=> {
			setDataLoaded(true);
			setPosts(res.data.data);		
			if(res.data.data.length > 0){
					const grandTotal = res.data.data.pop();
					if(grandTotal.grand_total){
						setGrandTotal(grandTotal); //store grandtotal in other state, and remove from result before displaying table
					}
				}
		}).catch((error)=>{
			setDataLoaded(true);
			// console.log(error.message);
		})
    }

	const data = async () => {
		//const res = await axios.get(
			// process.env.REACT_APP_API_URL+'product_package_report', {
		// params:{
        //         date_from: '2015/01/01/', 
        //         date_to: '2016/01/01/',   
        //         jc_user_id_no: 'DAVAOHQ',  
        //     }
        // })	

		//console.log(res.data);
		//console.log(res.data.data);
	    // setPosts(res.data.data);

		// if(res.data.data.length > 0){
		// 	const grandTotal = res.data.data.pop();
		// 	if(grandTotal.grand_total){
		// 		setGrandTotal(grandTotal); //store grandtotal in other state, and remove from result before displaying table
		// 	}
		// }
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};
	

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};
	const columns = [
		// "idno": "00507254",
		// "soldto": "RAUL ROSAS",
		// "date": "2015-12-12",
		// "packageid": -1,
		// "status": 1,
		// "packageamount": 15888,
		// "refno": "0198965",
		// "shipping": 1,
		// "type": "none"
		// total
		{
			name: "date",
			label: "Date",
			align:"center",

		},
		{
			name: "idno",
			label: "ID No",
			align:"center",
			options: {
				//filter: false,
				// display: "excluded",
			},
		},
		{
			name: "soldto",
			label: "Sold To",
			align:"center",

		},

		// {
		// 	name: "packageid",
		// 	label: "Package ID",

		// },
		// {
		// 	name: "status",
		// 	label: "status",

		// },
		// {
		// 	name: "refno",
		// 	label: "ref #",

		// },
		// {
		// 	name: "shipping",
		// 	label: "Shipping",

		// },
		{
			name: "type",
			label: "Package Type",
			align:"center",
		},
		// {
		// 	align:"center",
		// 	name: "packageamount",
		// 	label: "Package Amount",
		// 	options: {
		// 		customBodyRender: (value, tableMeta, updateValue) => {
		// 			return (
		// 					<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
		// 			);
		// 		  }
		// 		}
		// },
		{
			align:"right",
			name: "rebates",
			label: "Rebates",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},   {
            name: 'action',
            label: 'Action',
            options: {
				customBodyRender: (value, tableMeta, updateValue) => {

					return (
						<Button variant="contained" color="primary" onClick={(e) => {viewpackagedetails(tableMeta.rowData[0], "")}}>View</Button>
					);
				  }
				}
        }
	];

	const options = {
		filter: false,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		}, 
		download: false,  //add this
		print: false,
		viewColumns:false,//add this   
		downloadOptions: {
			filename : 'PartnerProductPackage.csv' //change filename of csv
		},
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/reports">
						<h2 className="header-title">Reports</h2>
					</NavLink>
					<Typography color="textPrimary">Partner Product Package Report</Typography>
				</Breadcrumbs>
			</div>
			<div className="page-container">
				<div style={style}>
					<Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>

						{/* <Grid item xs={2}>
							<Input  style ={{marginTop: "24px"}} placeholder="Branch ID No" inputProps={{ 'aria-label': 'branch id no' }} onChange={e => setuseridNo(e.target.value)}/>
						</Grid> */}

						<Grid item xs={2} sm={1} md={1} lg={1} xl={1}>
							<Button style ={{marginTop: "22px"}} variant="contained" color="primary" onClick={() => {dataFilter()}}>Search</Button>
						</Grid>
						{/* disabled temporary  until used*/} 
						<Grid item xs={10} sm={7} md={7} lg={7} xl={7} style={{ display: "flex", justifyContent: "flex-end" }}>
								<TextField
								  //https://medium.com/the-clever-dev/the-complete-guide-to-material-ui-grid-align-items-f4b472dba03f
								  style={{ marginTop: '2px', marginLeft: '40px'}} 
								  id="outlined"
								  type="text"
								  value={grandTotal.grand_total}
								  variant="outlined"
								  label="Grand Total"
        						  InputProps={{
        						    readOnly: true,
        						  }}
        						/>
						</Grid>	
					</Grid> 
				</div>
				
				{!dataLoaded ? (
					<Preloader />
				) : (
					<MUIDataTable
						title={
							<div>
								<h3 className="header-title" style={{color:"#339933"}}>
								Partner Product Package Report
								</h3>
							</div>
						}
						data={posts}
						columns={columns}
						options={options}
					/>
				)}
			</div>
		</div>
	);
};

export default PartnerProductPackage;
